"use client";
import React, { useEffect } from "react";
import { PanelGroup, Panel } from "@stadium/ui/src/components/accordion/bootstrap-panel";

import { AppendRichResult } from "@stadium/helpers/rich-results";
import { RICH_RESULT_TYPES } from "@stadium/constants";

import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

// import "./styles/Faq.module.scss";

const Faq = ({ doc }) => {
  const { heading, link, link_text, internal_link_id, background_color } = doc?.primary || {};
  const faqs = doc?.items?.map(({ question, answer }) => ({
    question: question[0]?.text,
    answer: answer[0]?.text,
  }));

  useEffect(() => {
    AppendRichResult(RICH_RESULT_TYPES.FAQ, faqs);
  }, [faqs]);

  return (
    <div
      className="px-0 py-4 px-md-4 px-lg-5 my-3 my-md-5 prismic-slice"
      style={{ background: background_color }}
    >
      {internal_link_id && (
        <span id={internal_link_id} className="scroll-point position-relative d-block" />
      )}
      <div className="container container-width faq-page-container">
        <div className="faq-container">
          <div className="sns-h2 mb-3 mb-md-5 text-theme-primary section-title text-md-center mobile-fs-32 pb-2 lh-1-point-25 same-size-title faq-slice-title">
            {textResolver(heading)}
          </div>
          <PanelGroup accordion id="faq-container">
            {doc.items.map((item, index) => {
              const { question, answer } = item;
              return (
                <Panel eventKey={index} className="faq-block" key={`question-${index}`}>
                  <Panel.Heading>
                    <Panel.Title toggle className="position-relative faq-question">
                      {textResolver(question)}
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body collapsible className="faq-answer">
                    {textResolver(answer)}
                  </Panel.Body>
                </Panel>
              );
            })}
          </PanelGroup>
        </div>
        {link?.url && (
          <div className="text-center mt-4 mt-md-5 pt-2">
            <PrismicLinkTag
              urlText={link_text}
              url={link?.url}
              target={link?.target}
              className="cta-green-18 program-link font-weight-bold"
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default Faq;
